export const SITE_URL = 'https://compopo.com';

export const COMPARE_PAGES = [
  // Gaming
  {
    slug: 'ps5-pro',
    searchQuery: 'PS5 Pro console',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים PS5 Pro',
    titleEn: 'Compare PS5 Pro Prices',
    descriptionHe: 'השוו מחירי PlayStation 5 Pro מ-eBay, AliExpress ו-Amazon. מצאו את המחיר הזול ביותר כולל משלוח לישראל.',
    descriptionEn: 'Compare PlayStation 5 Pro prices from eBay, AliExpress and Amazon. Find the lowest price including shipping.',
  },
  {
    slug: 'nintendo-switch-2',
    searchQuery: 'Nintendo Switch 2',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים Nintendo Switch 2',
    titleEn: 'Compare Nintendo Switch 2 Prices',
    descriptionHe: 'השוו מחירי Nintendo Switch 2 מחנויות בינלאומיות. מחירים מעודכנים כולל משלוח.',
    descriptionEn: 'Compare Nintendo Switch 2 prices from international stores. Updated prices including shipping.',
  },
  {
    slug: 'ps5-slim',
    searchQuery: 'PS5 Slim console',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים PS5 Slim',
    titleEn: 'Compare PS5 Slim Prices',
    descriptionHe: 'השוו מחירי PlayStation 5 Slim מכל העולם. מצאו את העסקה הטובה ביותר.',
    descriptionEn: 'Compare PlayStation 5 Slim prices worldwide. Find the best deal.',
  },
  {
    slug: 'xbox-series-x',
    searchQuery: 'Xbox Series X console',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים Xbox Series X',
    titleEn: 'Compare Xbox Series X Prices',
    descriptionHe: 'השוו מחירי Xbox Series X מ-eBay, AliExpress ו-Amazon.',
    descriptionEn: 'Compare Xbox Series X prices from eBay, AliExpress and Amazon.',
  },
  {
    slug: 'dualsense-controller',
    searchQuery: 'DualSense controller',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים בקר DualSense',
    titleEn: 'Compare DualSense Controller Prices',
    descriptionHe: 'השוו מחירי בקר DualSense ל-PlayStation מחנויות בינלאומיות.',
    descriptionEn: 'Compare DualSense controller prices from international stores.',
  },
  {
    slug: 'oculus-quest-3',
    searchQuery: 'Meta Quest 3',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים Meta Quest 3',
    titleEn: 'Compare Meta Quest 3 Prices',
    descriptionHe: 'השוו מחירי Meta Quest 3 מחנויות מובילות בעולם.',
    descriptionEn: 'Compare Meta Quest 3 prices from leading global stores.',
  },
  {
    slug: 'steam-deck',
    searchQuery: 'Steam Deck',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים Steam Deck',
    titleEn: 'Compare Steam Deck Prices',
    descriptionHe: 'השוו מחירי Steam Deck מ-eBay, AliExpress ו-Amazon.',
    descriptionEn: 'Compare Steam Deck prices from eBay, AliExpress and Amazon.',
  },
  {
    slug: 'gaming-headset',
    searchQuery: 'gaming headset wireless',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'אוזניות גיימינג — השוואת מחירים',
    titleEn: 'Compare Gaming Headset Prices',
    descriptionHe: 'השוו מחירי אוזניות גיימינג אלחוטיות מחנויות בינלאומיות.',
    descriptionEn: 'Compare wireless gaming headset prices from international stores.',
  },
  {
    slug: 'xbox-series-s',
    searchQuery: 'Xbox Series S console',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים Xbox Series S',
    titleEn: 'Compare Xbox Series S Prices',
    descriptionHe: 'השוו מחירי Xbox Series S מחנויות בינלאומיות כולל משלוח.',
    descriptionEn: 'Compare Xbox Series S prices from international stores including shipping.',
  },
  {
    slug: 'gaming-chair',
    searchQuery: 'gaming chair ergonomic',
    category: 'gaming',
    categoryHe: 'גיימינג',
    categoryEn: 'Gaming',
    titleHe: 'השוואת מחירים כיסא גיימינג',
    titleEn: 'Compare Gaming Chair Prices',
    descriptionHe: 'השוו מחירי כיסאות גיימינג ארגונומיים מחנויות בעולם.',
    descriptionEn: 'Compare ergonomic gaming chair prices from stores worldwide.',
  },
  // Phones & tablets
  {
    slug: 'iphone-16-pro',
    searchQuery: 'iPhone 16 Pro',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים iPhone 16 Pro',
    titleEn: 'Compare iPhone 16 Pro Prices',
    descriptionHe: 'השוו מחירי iPhone 16 Pro מחנויות בינלאומיות. מחירים כולל משלוח.',
    descriptionEn: 'Compare iPhone 16 Pro prices from international stores including shipping.',
  },
  {
    slug: 'samsung-galaxy-s25-ultra',
    searchQuery: 'Samsung Galaxy S25 Ultra',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים Galaxy S25 Ultra',
    titleEn: 'Compare Galaxy S25 Ultra Prices',
    descriptionHe: 'השוו מחירי Samsung Galaxy S25 Ultra מכל העולם.',
    descriptionEn: 'Compare Samsung Galaxy S25 Ultra prices worldwide.',
  },
  {
    slug: 'ipad-pro',
    searchQuery: 'iPad Pro',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים iPad Pro',
    titleEn: 'Compare iPad Pro Prices',
    descriptionHe: 'השוו מחירי iPad Pro מ-eBay, AliExpress ו-Amazon.',
    descriptionEn: 'Compare iPad Pro prices from eBay, AliExpress and Amazon.',
  },
  {
    slug: 'samsung-galaxy-tab-s9',
    searchQuery: 'Samsung Galaxy Tab S9',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים Galaxy Tab S9',
    titleEn: 'Compare Galaxy Tab S9 Prices',
    descriptionHe: 'השוו מחירי Samsung Galaxy Tab S9 מחנויות בינלאומיות.',
    descriptionEn: 'Compare Samsung Galaxy Tab S9 prices from international stores.',
  },
  {
    slug: 'airpods-pro',
    searchQuery: 'Apple AirPods Pro',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים AirPods Pro',
    titleEn: 'Compare AirPods Pro Prices',
    descriptionHe: 'השוו מחירי Apple AirPods Pro מחנויות מובילות בעולם.',
    descriptionEn: 'Compare Apple AirPods Pro prices from leading global stores.',
  },
  {
    slug: 'apple-watch-series-10',
    searchQuery: 'Apple Watch Series 10',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים Apple Watch',
    titleEn: 'Compare Apple Watch Prices',
    descriptionHe: 'השוו מחירי Apple Watch Series 10 מחנויות בינלאומיות.',
    descriptionEn: 'Compare Apple Watch Series 10 prices from international stores.',
  },
  {
    slug: 'google-pixel-9',
    searchQuery: 'Google Pixel 9 Pro',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים Google Pixel 9',
    titleEn: 'Compare Google Pixel 9 Prices',
    descriptionHe: 'השוו מחירי Google Pixel 9 Pro מחנויות בינלאומיות.',
    descriptionEn: 'Compare Google Pixel 9 Pro prices from international stores.',
  },
  {
    slug: 'samsung-galaxy-buds',
    searchQuery: 'Samsung Galaxy Buds 3 Pro',
    category: 'phones',
    categoryHe: 'סמארטפונים וטאבלטים',
    categoryEn: 'Phones & Tablets',
    titleHe: 'השוואת מחירים Galaxy Buds',
    titleEn: 'Compare Galaxy Buds Prices',
    descriptionHe: 'השוו מחירי Samsung Galaxy Buds מחנויות בעולם.',
    descriptionEn: 'Compare Samsung Galaxy Buds prices from stores worldwide.',
  },
  // Electronics & home
  {
    slug: 'dyson-v15',
    searchQuery: 'Dyson V15 Detect',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים Dyson V15',
    titleEn: 'Compare Dyson V15 Prices',
    descriptionHe: 'השוו מחירי Dyson V15 Detect מחנויות בינלאומיות.',
    descriptionEn: 'Compare Dyson V15 Detect prices from international stores.',
  },
  {
    slug: 'sony-wh-1000xm5',
    searchQuery: 'Sony WH-1000XM5',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים Sony WH-1000XM5',
    titleEn: 'Compare Sony WH-1000XM5 Prices',
    descriptionHe: 'השוו מחירי אוזניות Sony WH-1000XM5 מכל העולם.',
    descriptionEn: 'Compare Sony WH-1000XM5 headphone prices worldwide.',
  },
  {
    slug: 'macbook-air-m3',
    searchQuery: 'MacBook Air M3',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים MacBook Air M3',
    titleEn: 'Compare MacBook Air M3 Prices',
    descriptionHe: 'השוו מחירי MacBook Air M3 מ-eBay, AliExpress ו-Amazon.',
    descriptionEn: 'Compare MacBook Air M3 prices from eBay, AliExpress and Amazon.',
  },
  {
    slug: 'samsung-980-pro-ssd',
    searchQuery: 'Samsung 980 PRO SSD',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים Samsung 980 PRO',
    titleEn: 'Compare Samsung 980 PRO SSD Prices',
    descriptionHe: 'השוו מחירי Samsung 980 PRO SSD מחנויות בינלאומיות.',
    descriptionEn: 'Compare Samsung 980 PRO SSD prices from international stores.',
  },
  {
    slug: 'nespresso-vertuo',
    searchQuery: 'Nespresso Vertuo',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים Nespresso Vertuo',
    titleEn: 'Compare Nespresso Vertuo Prices',
    descriptionHe: 'השוו מחירי מכונת Nespresso Vertuo מחנויות בעולם.',
    descriptionEn: 'Compare Nespresso Vertuo prices from stores worldwide.',
  },
  {
    slug: 'robot-vacuum',
    searchQuery: 'robot vacuum cleaner',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'שואב אבק רובוטי — השוואת מחירים',
    titleEn: 'Compare Robot Vacuum Prices',
    descriptionHe: 'השוו מחירי שואבי אבק רובוטיים מחנויות בינלאומיות.',
    descriptionEn: 'Compare robot vacuum cleaner prices from international stores.',
  },
  {
    slug: 'lg-oled-tv',
    searchQuery: 'LG OLED TV 55 inch',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים טלוויזיית LG OLED',
    titleEn: 'Compare LG OLED TV Prices',
    descriptionHe: 'השוו מחירי טלוויזיות LG OLED מחנויות בינלאומיות.',
    descriptionEn: 'Compare LG OLED TV prices from international stores.',
  },
  {
    slug: 'dyson-airwrap',
    searchQuery: 'Dyson Airwrap',
    category: 'electronics',
    categoryHe: 'אלקטרוניקה ובית',
    categoryEn: 'Electronics & Home',
    titleHe: 'השוואת מחירים Dyson Airwrap',
    titleEn: 'Compare Dyson Airwrap Prices',
    descriptionHe: 'השוו מחירי Dyson Airwrap מחנויות בעולם.',
    descriptionEn: 'Compare Dyson Airwrap prices from stores worldwide.',
  },
  // Audio
  {
    slug: 'bose-quietcomfort-ultra',
    searchQuery: 'Bose QuietComfort Ultra',
    category: 'audio',
    categoryHe: 'אודיו',
    categoryEn: 'Audio & Headphones',
    titleHe: 'השוואת מחירים Bose QuietComfort Ultra',
    titleEn: 'Compare Bose QuietComfort Ultra Prices',
    descriptionHe: 'השוו מחירי אוזניות Bose QuietComfort Ultra מחנויות בינלאומיות.',
    descriptionEn: 'Compare Bose QuietComfort Ultra prices from international stores.',
  },
  {
    slug: 'jbl-charge-5',
    searchQuery: 'JBL Charge 5',
    category: 'audio',
    categoryHe: 'אודיו',
    categoryEn: 'Audio & Headphones',
    titleHe: 'השוואת מחירים JBL Charge 5',
    titleEn: 'Compare JBL Charge 5 Prices',
    descriptionHe: 'השוו מחירי רמקול JBL Charge 5 מחנויות בעולם.',
    descriptionEn: 'Compare JBL Charge 5 speaker prices from stores worldwide.',
  },
  {
    slug: 'airpods-max',
    searchQuery: 'Apple AirPods Max',
    category: 'audio',
    categoryHe: 'אודיו',
    categoryEn: 'Audio & Headphones',
    titleHe: 'השוואת מחירים AirPods Max',
    titleEn: 'Compare AirPods Max Prices',
    descriptionHe: 'השוו מחירי Apple AirPods Max מחנויות בינלאומיות.',
    descriptionEn: 'Compare Apple AirPods Max prices from international stores.',
  },
  {
    slug: 'sonos-era-100',
    searchQuery: 'Sonos Era 100',
    category: 'audio',
    categoryHe: 'אודיו',
    categoryEn: 'Audio & Headphones',
    titleHe: 'השוואת מחירים Sonos Era 100',
    titleEn: 'Compare Sonos Era 100 Prices',
    descriptionHe: 'השוו מחירי רמקול Sonos Era 100 מחנויות בעולם.',
    descriptionEn: 'Compare Sonos Era 100 prices from stores worldwide.',
  },
  // Computing
  {
    slug: 'macbook-pro-m3',
    searchQuery: 'MacBook Pro M3',
    category: 'computing',
    categoryHe: 'מחשבים',
    categoryEn: 'Computers & Laptops',
    titleHe: 'השוואת מחירים MacBook Pro M3',
    titleEn: 'Compare MacBook Pro M3 Prices',
    descriptionHe: 'השוו מחירי MacBook Pro M3 מ-eBay, AliExpress ו-Amazon.',
    descriptionEn: 'Compare MacBook Pro M3 prices from eBay, AliExpress and Amazon.',
  },
  {
    slug: 'dell-xps-15',
    searchQuery: 'Dell XPS 15 laptop',
    category: 'computing',
    categoryHe: 'מחשבים',
    categoryEn: 'Computers & Laptops',
    titleHe: 'השוואת מחירים Dell XPS 15',
    titleEn: 'Compare Dell XPS 15 Prices',
    descriptionHe: 'השוו מחירי Dell XPS 15 מחנויות בינלאומיות.',
    descriptionEn: 'Compare Dell XPS 15 laptop prices from international stores.',
  },
  {
    slug: 'gaming-monitor-27',
    searchQuery: '27 inch gaming monitor 144Hz',
    category: 'computing',
    categoryHe: 'מחשבים',
    categoryEn: 'Computers & Laptops',
    titleHe: 'השוואת מחירים מסך גיימינג 27',
    titleEn: 'Compare 27-inch Gaming Monitor Prices',
    descriptionHe: 'השוו מחירי מסכי גיימינג 27 אינץ מחנויות בעולם.',
    descriptionEn: 'Compare 27-inch gaming monitor prices from stores worldwide.',
  },
  {
    slug: 'ipad-air',
    searchQuery: 'iPad Air M2',
    category: 'computing',
    categoryHe: 'מחשבים',
    categoryEn: 'Computers & Laptops',
    titleHe: 'השוואת מחירים iPad Air',
    titleEn: 'Compare iPad Air Prices',
    descriptionHe: 'השוו מחירי iPad Air מחנויות בינלאומיות.',
    descriptionEn: 'Compare iPad Air prices from international stores.',
  },
  // Sports & Fitness
  {
    slug: 'garmin-forerunner-265',
    searchQuery: 'Garmin Forerunner 265',
    category: 'sports',
    categoryHe: 'ספורט וכושר',
    categoryEn: 'Sports & Fitness',
    titleHe: 'השוואת מחירים Garmin Forerunner 265',
    titleEn: 'Compare Garmin Forerunner 265 Prices',
    descriptionHe: 'השוו מחירי שעון Garmin Forerunner 265 מחנויות בינלאומיות.',
    descriptionEn: 'Compare Garmin Forerunner 265 prices from international stores.',
  },
  {
    slug: 'adjustable-dumbbells',
    searchQuery: 'adjustable dumbbells set',
    category: 'sports',
    categoryHe: 'ספורט וכושר',
    categoryEn: 'Sports & Fitness',
    titleHe: 'השוואת מחירים משקולות מתכוונות',
    titleEn: 'Compare Adjustable Dumbbells Prices',
    descriptionHe: 'השוו מחירי סט משקולות מתכוונות מחנויות בעולם.',
    descriptionEn: 'Compare adjustable dumbbells set prices from stores worldwide.',
  },
  {
    slug: 'yoga-mat',
    searchQuery: 'premium yoga mat',
    category: 'sports',
    categoryHe: 'ספורט וכושר',
    categoryEn: 'Sports & Fitness',
    titleHe: 'השוואת מחירים מזרן יוגה',
    titleEn: 'Compare Yoga Mat Prices',
    descriptionHe: 'השוו מחירי מזרני יוגה איכותיים מחנויות בינלאומיות.',
    descriptionEn: 'Compare premium yoga mat prices from international stores.',
  },
  {
    slug: 'exercise-bike',
    searchQuery: 'indoor exercise bike',
    category: 'sports',
    categoryHe: 'ספורט וכושר',
    categoryEn: 'Sports & Fitness',
    titleHe: 'השוואת מחירים אופני כושר',
    titleEn: 'Compare Exercise Bike Prices',
    descriptionHe: 'השוו מחירי אופני כושר לבית מחנויות בעולם.',
    descriptionEn: 'Compare indoor exercise bike prices from stores worldwide.',
  },
  // Beauty & Grooming
  {
    slug: 'dyson-airwrap',
    searchQuery: 'Dyson Airwrap',
    category: 'beauty',
    categoryHe: 'יופי וטיפוח',
    categoryEn: 'Beauty & Grooming',
    titleHe: 'השוואת מחירים Dyson Airwrap',
    titleEn: 'Compare Dyson Airwrap Prices',
    descriptionHe: 'השוו מחירי Dyson Airwrap מחנויות בינלאומיות כולל משלוח.',
    descriptionEn: 'Compare Dyson Airwrap prices from international stores including shipping.',
  },
  {
    slug: 'philips-shaver',
    searchQuery: 'Philips electric shaver series 9000',
    category: 'beauty',
    categoryHe: 'יופי וטיפוח',
    categoryEn: 'Beauty & Grooming',
    titleHe: 'השוואת מחירים מכונת גילוח Philips',
    titleEn: 'Compare Philips Electric Shaver Prices',
    descriptionHe: 'השוו מחירי מכונות גילוח Philips מחנויות בעולם.',
    descriptionEn: 'Compare Philips electric shaver prices from stores worldwide.',
  },
  {
    slug: 'designer-perfume',
    searchQuery: 'designer perfume men',
    category: 'beauty',
    categoryHe: 'יופי וטיפוח',
    categoryEn: 'Beauty & Grooming',
    titleHe: 'השוואת מחירים בושם מעצבים',
    titleEn: 'Compare Designer Perfume Prices',
    descriptionHe: 'השוו מחירי בושמי מעצבים מחנויות בינלאומיות.',
    descriptionEn: 'Compare designer perfume prices from international stores.',
  },
  {
    slug: 'ghd-hair-straightener',
    searchQuery: 'GHD hair straightener',
    category: 'beauty',
    categoryHe: 'יופי וטיפוח',
    categoryEn: 'Beauty & Grooming',
    titleHe: 'השוואת מחירים מחליק שיער GHD',
    titleEn: 'Compare GHD Hair Straightener Prices',
    descriptionHe: 'השוו מחירי מחליקי שיער GHD מחנויות בעולם.',
    descriptionEn: 'Compare GHD hair straightener prices from stores worldwide.',
  },
  // Baby & Kids
  {
    slug: 'baby-stroller',
    searchQuery: 'baby stroller',
    category: 'baby',
    categoryHe: 'תינוקות וילדים',
    categoryEn: 'Baby & Kids',
    titleHe: 'השוואת מחירים עגלת תינוק',
    titleEn: 'Compare Baby Stroller Prices',
    descriptionHe: 'השוו מחירי עגלות תינוק מחנויות בינלאומיות.',
    descriptionEn: 'Compare baby stroller prices from international stores.',
  },
  {
    slug: 'infant-car-seat',
    searchQuery: 'infant car seat',
    category: 'baby',
    categoryHe: 'תינוקות וילדים',
    categoryEn: 'Baby & Kids',
    titleHe: 'השוואת מחירים כיסא בטיחות לתינוק',
    titleEn: 'Compare Infant Car Seat Prices',
    descriptionHe: 'השוו מחירי כיסאות בטיחות לתינוק מחנויות בעולם.',
    descriptionEn: 'Compare infant car seat prices from stores worldwide.',
  },
  {
    slug: 'baby-monitor',
    searchQuery: 'baby monitor video',
    category: 'baby',
    categoryHe: 'תינוקות וילדים',
    categoryEn: 'Baby & Kids',
    titleHe: 'השוואת מחירים מוניטור תינוק',
    titleEn: 'Compare Baby Monitor Prices',
    descriptionHe: 'השוו מחירי מוניטורי תינוק מחנויות בינלאומיות.',
    descriptionEn: 'Compare baby monitor prices from international stores.',
  },
  {
    slug: 'baby-high-chair',
    searchQuery: 'baby high chair',
    category: 'baby',
    categoryHe: 'תינוקות וילדים',
    categoryEn: 'Baby & Kids',
    titleHe: 'השוואת מחירים כיסא אוכל לתינוק',
    titleEn: 'Compare Baby High Chair Prices',
    descriptionHe: 'השוו מחירי כיסאות אוכל לתינוק מחנויות בעולם.',
    descriptionEn: 'Compare baby high chair prices from stores worldwide.',
  },
  // Pets
  {
    slug: 'pets-supplies',
    searchQuery: 'Pets Supplies',
    category: 'pets',
    categoryHe: 'חיות מחמד',
    categoryEn: 'Pets',
    titleHe: 'השוואת מחירים ציוד לחיות',
    titleEn: 'Compare Pet Supplies Prices',
    descriptionHe: 'השוו מחירי ציוד לחיות מחנויות בינלאומיות.',
    descriptionEn: 'Compare pet supplies prices from international stores.',
  },
  {
    slug: 'automatic-pet-feeder',
    searchQuery: 'automatic pet feeder',
    category: 'pets',
    categoryHe: 'חיות מחמד',
    categoryEn: 'Pets',
    titleHe: 'השוואת מחירים מאכיל אוטומטי לחיות',
    titleEn: 'Compare Automatic Pet Feeder Prices',
    descriptionHe: 'השוו מחירי מאכילים אוטומטיים לחיות מחנויות בעולם.',
    descriptionEn: 'Compare automatic pet feeder prices from stores worldwide.',
  },
  {
    slug: 'cat-litter-box',
    searchQuery: 'automatic cat litter box',
    category: 'pets',
    categoryHe: 'חיות מחמד',
    categoryEn: 'Pets',
    titleHe: 'השוואת מחירים ארגז חול אוטומטי לחתול',
    titleEn: 'Compare Automatic Cat Litter Box Prices',
    descriptionHe: 'השוו מחירי ארגזי חול אוטומטיים לחתולים מחנויות בינלאומיות.',
    descriptionEn: 'Compare automatic cat litter box prices from international stores.',
  },
  {
    slug: 'dog-harness',
    searchQuery: 'dog harness',
    category: 'pets',
    categoryHe: 'חיות מחמד',
    categoryEn: 'Pets',
    titleHe: 'השוואת מחירים רתמה לכלב',
    titleEn: 'Compare Dog Harness Prices',
    descriptionHe: 'השוו מחירי רתמות לכלבים מחנויות בעולם.',
    descriptionEn: 'Compare dog harness prices from stores worldwide.',
  },
  // Kitchen & Appliances
  {
    slug: 'kitchenaid-mixer',
    searchQuery: 'KitchenAid stand mixer',
    category: 'kitchen',
    categoryHe: 'מטבח ומכשירי חשמל',
    categoryEn: 'Kitchen & Appliances',
    titleHe: 'השוואת מחירים מיקסר KitchenAid',
    titleEn: 'Compare KitchenAid Mixer Prices',
    descriptionHe: 'השוו מחירי מיקסר KitchenAid מחנויות בינלאומיות.',
    descriptionEn: 'Compare KitchenAid stand mixer prices from international stores.',
  },
  {
    slug: 'espresso-machine',
    searchQuery: 'espresso machine',
    category: 'kitchen',
    categoryHe: 'מטבח ומכשירי חשמל',
    categoryEn: 'Kitchen & Appliances',
    titleHe: 'השוואת מחירים מכונת אספרסו',
    titleEn: 'Compare Espresso Machine Prices',
    descriptionHe: 'השוו מחירי מכונות אספרסו מחנויות בעולם.',
    descriptionEn: 'Compare espresso machine prices from stores worldwide.',
  },
  {
    slug: 'ninja-blender',
    searchQuery: 'Ninja blender',
    category: 'kitchen',
    categoryHe: 'מטבח ומכשירי חשמל',
    categoryEn: 'Kitchen & Appliances',
    titleHe: 'השוואת מחירים בלנדר Ninja',
    titleEn: 'Compare Ninja Blender Prices',
    descriptionHe: 'השוו מחירי בלנדר Ninja מחנויות בינלאומיות.',
    descriptionEn: 'Compare Ninja blender prices from international stores.',
  },
  {
    slug: 'ninja-air-fryer',
    searchQuery: 'Ninja air fryer',
    category: 'kitchen',
    categoryHe: 'מטבח ומכשירי חשמל',
    categoryEn: 'Kitchen & Appliances',
    titleHe: 'השוואת מחירים Air Fryer Ninja',
    titleEn: 'Compare Ninja Air Fryer Prices',
    descriptionHe: 'השוו מחירי Air Fryer של Ninja מחנויות בעולם.',
    descriptionEn: 'Compare Ninja air fryer prices from stores worldwide.',
  },
  // Tools & DIY
  {
    slug: 'diy-tools',
    searchQuery: 'Do it yourself tools',
    category: 'tools',
    categoryHe: 'כלי עבודה ו-DIY',
    categoryEn: 'Tools & DIY',
    titleHe: 'השוואת מחירים כלי עבודה DIY',
    titleEn: 'Compare DIY Tools Prices',
    descriptionHe: 'השוו מחירי כלי עבודה ו-DIY מחנויות בינלאומיות.',
    descriptionEn: 'Compare DIY tools prices from international stores.',
  },
  {
    slug: 'cordless-drill',
    searchQuery: 'DeWalt cordless drill',
    category: 'tools',
    categoryHe: 'כלי עבודה ו-DIY',
    categoryEn: 'Tools & DIY',
    titleHe: 'השוואת מחירים מקדחה נטענת DeWalt',
    titleEn: 'Compare DeWalt Cordless Drill Prices',
    descriptionHe: 'השוו מחירי מקדחות נטענות DeWalt מחנויות בעולם.',
    descriptionEn: 'Compare DeWalt cordless drill prices from stores worldwide.',
  },
  {
    slug: 'electric-lawn-mower',
    searchQuery: 'electric lawn mower',
    category: 'tools',
    categoryHe: 'כלי עבודה ו-DIY',
    categoryEn: 'Tools & DIY',
    titleHe: 'השוואת מחירים מכסחת דשא חשמלית',
    titleEn: 'Compare Electric Lawn Mower Prices',
    descriptionHe: 'השוו מחירי מכסחות דשא חשמליות מחנויות בינלאומיות.',
    descriptionEn: 'Compare electric lawn mower prices from international stores.',
  },
  {
    slug: 'pressure-washer',
    searchQuery: 'pressure washer',
    category: 'tools',
    categoryHe: 'כלי עבודה ו-DIY',
    categoryEn: 'Tools & DIY',
    titleHe: 'השוואת מחירים מכונת שטיפה בלחץ',
    titleEn: 'Compare Pressure Washer Prices',
    descriptionHe: 'השוו מחירי מכונות שטיפה בלחץ מחנויות בעולם.',
    descriptionEn: 'Compare pressure washer prices from stores worldwide.',
  },
  // Watches & Jewelry
  {
    slug: 'casio-g-shock',
    searchQuery: 'Casio G-Shock watch',
    category: 'watches',
    categoryHe: 'שעונים ותכשיטים',
    categoryEn: 'Watches & Jewelry',
    titleHe: 'השוואת מחירים Casio G-Shock',
    titleEn: 'Compare Casio G-Shock Prices',
    descriptionHe: 'השוו מחירי שעוני Casio G-Shock מחנויות בינלאומיות.',
    descriptionEn: 'Compare Casio G-Shock watch prices from international stores.',
  },
  {
    slug: 'apple-watch-ultra',
    searchQuery: 'Apple Watch Ultra 2',
    category: 'watches',
    categoryHe: 'שעונים ותכשיטים',
    categoryEn: 'Watches & Jewelry',
    titleHe: 'השוואת מחירים Apple Watch Ultra',
    titleEn: 'Compare Apple Watch Ultra Prices',
    descriptionHe: 'השוו מחירי Apple Watch Ultra מחנויות בעולם.',
    descriptionEn: 'Compare Apple Watch Ultra prices from stores worldwide.',
  },
  {
    slug: 'samsung-galaxy-watch',
    searchQuery: 'Samsung Galaxy Watch 7',
    category: 'watches',
    categoryHe: 'שעונים ותכשיטים',
    categoryEn: 'Watches & Jewelry',
    titleHe: 'השוואת מחירים Samsung Galaxy Watch',
    titleEn: 'Compare Samsung Galaxy Watch Prices',
    descriptionHe: 'השוו מחירי Samsung Galaxy Watch מחנויות בינלאומיות.',
    descriptionEn: 'Compare Samsung Galaxy Watch prices from international stores.',
  },
  {
    slug: 'fossil-watch',
    searchQuery: 'Fossil mens watch',
    category: 'watches',
    categoryHe: 'שעונים ותכשיטים',
    categoryEn: 'Watches & Jewelry',
    titleHe: 'השוואת מחירים שעון Fossil',
    titleEn: 'Compare Fossil Watch Prices',
    descriptionHe: 'השוו מחירי שעוני Fossil מחנויות בעולם.',
    descriptionEn: 'Compare Fossil watch prices from stores worldwide.',
  },
  // Toys & Games
  {
    slug: 'lego-sets',
    searchQuery: 'LEGO sets',
    category: 'toys',
    categoryHe: 'צעצועים ומשחקים',
    categoryEn: 'Toys & Games',
    titleHe: 'השוואת מחירים LEGO',
    titleEn: 'Compare LEGO Sets Prices',
    descriptionHe: 'השוו מחירי ערכות LEGO מחנויות בינלאומיות.',
    descriptionEn: 'Compare LEGO sets prices from international stores.',
  },
  {
    slug: 'kids-toys',
    searchQuery: 'Kids Toys',
    category: 'toys',
    categoryHe: 'צעצועים ומשחקים',
    categoryEn: 'Toys & Games',
    titleHe: 'השוואת מחירים צעצועים לילדים',
    titleEn: 'Compare Kids Toys Prices',
    descriptionHe: 'השוו מחירי צעצועים לילדים מחנויות בעולם.',
    descriptionEn: 'Compare kids toys prices from stores worldwide.',
  },
  {
    slug: 'board-games',
    searchQuery: 'popular board games',
    category: 'toys',
    categoryHe: 'צעצועים ומשחקים',
    categoryEn: 'Toys & Games',
    titleHe: 'השוואת מחירים משחקי קופסה',
    titleEn: 'Compare Board Games Prices',
    descriptionHe: 'השוו מחירי משחקי קופסה פופולריים מחנויות בינלאומיות.',
    descriptionEn: 'Compare popular board games prices from international stores.',
  },
  {
    slug: 'jigsaw-puzzle',
    searchQuery: '1000 piece jigsaw puzzle',
    category: 'toys',
    categoryHe: 'צעצועים ומשחקים',
    categoryEn: 'Toys & Games',
    titleHe: 'השוואת מחירים פאזל 1000 חלקים',
    titleEn: 'Compare Jigsaw Puzzle Prices',
    descriptionHe: 'השוו מחירי פאזלים מחנויות בעולם.',
    descriptionEn: 'Compare jigsaw puzzle prices from stores worldwide.',
  },
  // Fashion
  {
    slug: 'fashion-accessories',
    searchQuery: 'Fashion Accessories',
    category: 'fashion',
    categoryHe: 'אופנה',
    categoryEn: 'Fashion',
    titleHe: 'השוואת מחירים אביזרי אופנה',
    titleEn: 'Compare Fashion Accessories Prices',
    descriptionHe: 'השוו מחירי אביזרי אופנה מחנויות בעולם.',
    descriptionEn: 'Compare fashion accessories prices from stores worldwide.',
  },
  {
    slug: 'nike-air-max-90',
    searchQuery: 'Nike Air Max 90 sneakers',
    category: 'fashion',
    categoryHe: 'אופנה',
    categoryEn: 'Fashion',
    titleHe: 'השוואת מחירים Nike Air Max 90',
    titleEn: 'Compare Nike Air Max 90 Prices',
    descriptionHe: 'השוו מחירי Nike Air Max 90 מחנויות בינלאומיות כולל משלוח.',
    descriptionEn: 'Compare Nike Air Max 90 sneaker prices from international stores including shipping.',
  },
  {
    slug: 'ray-ban-aviator',
    searchQuery: 'Ray-Ban Aviator sunglasses',
    category: 'fashion',
    categoryHe: 'אופנה',
    categoryEn: 'Fashion',
    titleHe: 'השוואת מחירים Ray-Ban Aviator',
    titleEn: 'Compare Ray-Ban Aviator Prices',
    descriptionHe: 'השוו מחירי משקפי Ray-Ban Aviator מחנויות בעולם.',
    descriptionEn: 'Compare Ray-Ban Aviator sunglasses prices from stores worldwide.',
  },
  {
    slug: 'adidas-samba',
    searchQuery: 'Adidas Samba sneakers',
    category: 'fashion',
    categoryHe: 'אופנה',
    categoryEn: 'Fashion',
    titleHe: 'השוואת מחירים Adidas Samba',
    titleEn: 'Compare Adidas Samba Prices',
    descriptionHe: 'השוו מחירי Adidas Samba מחנויות בינלאומיות.',
    descriptionEn: 'Compare Adidas Samba sneaker prices from international stores.',
  },
  // More categories
  {
    slug: 'smartphones',
    searchQuery: 'Smartphones',
    category: 'categories',
    categoryHe: 'קטגוריות נוספות',
    categoryEn: 'More Categories',
    titleHe: 'השוואת מחירים סמארטפונים',
    titleEn: 'Compare Smartphone Prices',
    descriptionHe: 'השוו מחירי סמארטפונים מחנויות בינלאומיות. מצאו את המחיר הזול ביותר.',
    descriptionEn: 'Compare smartphone prices from international stores. Find the lowest price.',
  },
  {
    slug: 'bluetooth-speakers',
    searchQuery: 'Bluetooth Speakers',
    category: 'categories',
    categoryHe: 'קטגוריות נוספות',
    categoryEn: 'More Categories',
    titleHe: 'השוואת מחירים רמקולי Bluetooth',
    titleEn: 'Compare Bluetooth Speaker Prices',
    descriptionHe: 'השוו מחירי רמקולי Bluetooth מחנויות בינלאומיות.',
    descriptionEn: 'Compare Bluetooth speaker prices from international stores.',
  },
  {
    slug: 'home-decor',
    searchQuery: 'Home Decor',
    category: 'categories',
    categoryHe: 'קטגוריות נוספות',
    categoryEn: 'More Categories',
    titleHe: 'השוואת מחירים עיצוב הבית',
    titleEn: 'Compare Home Decor Prices',
    descriptionHe: 'השוו מחירי מוצרי עיצוב הבית מחנויות בינלאומיות.',
    descriptionEn: 'Compare home decor prices from international stores.',
  },
  {
    slug: 'electronics-category',
    searchQuery: 'Electronics',
    category: 'categories',
    categoryHe: 'קטגוריות נוספות',
    categoryEn: 'More Categories',
    titleHe: 'השוואת מחירים אלקטרוניקה',
    titleEn: 'Compare Electronics Prices',
    descriptionHe: 'השוו מחירי מוצרי אלקטרוניקה מחנויות בעולם.',
    descriptionEn: 'Compare electronics prices from stores worldwide.',
  },
];

export function getComparePageBySlug(slug) {
  return COMPARE_PAGES.find((page) => page.slug === slug) || null;
}

export const HOME_CATEGORY_SECTIONS = [
  {
    key: 'gaming',
    slugs: ['ps5-pro', 'nintendo-switch-2', 'steam-deck', 'dualsense-controller'],
  },
  {
    key: 'phones',
    slugs: ['iphone-16-pro', 'samsung-galaxy-s25-ultra', 'airpods-pro', 'google-pixel-9'],
  },
  {
    key: 'electronics',
    slugs: ['dyson-v15', 'robot-vacuum', 'lg-oled-tv', 'nespresso-vertuo'],
  },
  {
    key: 'audio',
    slugs: ['sony-wh-1000xm5', 'airpods-max', 'bose-quietcomfort-ultra', 'jbl-charge-5'],
  },
  {
    key: 'computing',
    slugs: ['macbook-air-m3', 'gaming-monitor-27', 'macbook-pro-m3', 'ipad-pro'],
  },
  {
    key: 'fashion',
    slugs: ['nike-air-max-90', 'adidas-samba', 'ray-ban-aviator', 'fashion-accessories'],
  },
  {
    key: 'sports',
    slugs: ['garmin-forerunner-265', 'adjustable-dumbbells', 'yoga-mat', 'exercise-bike'],
  },
  {
    key: 'beauty',
    slugs: ['dyson-airwrap', 'philips-shaver', 'designer-perfume', 'ghd-hair-straightener'],
  },
  {
    key: 'baby',
    slugs: ['baby-stroller', 'infant-car-seat', 'baby-monitor', 'baby-high-chair'],
  },
  {
    key: 'pets',
    slugs: ['pets-supplies', 'automatic-pet-feeder', 'cat-litter-box', 'dog-harness'],
  },
  {
    key: 'kitchen',
    slugs: ['kitchenaid-mixer', 'espresso-machine', 'ninja-blender', 'ninja-air-fryer'],
  },
  {
    key: 'tools',
    slugs: ['diy-tools', 'cordless-drill', 'electric-lawn-mower', 'pressure-washer'],
  },
  {
    key: 'toys',
    slugs: ['lego-sets', 'kids-toys', 'board-games', 'jigsaw-puzzle'],
  },
];

export const HOME_POPULAR_SEARCHES = [
  { query: 'DualSense controller', labelHe: 'בקר DualSense', labelEn: 'DualSense' },
  { query: 'AirPods Pro', labelHe: 'AirPods Pro', labelEn: 'AirPods Pro' },
  { query: 'LEGO sets', labelHe: 'ערכות LEGO', labelEn: 'LEGO sets' },
  { query: 'MacBook Air M3', labelHe: 'MacBook Air', labelEn: 'MacBook Air' },
  { query: 'gaming headset', labelHe: 'אוזניות גיימינג', labelEn: 'Gaming headset' },
  { query: 'iPhone 16 Pro', labelHe: 'iPhone 16 Pro', labelEn: 'iPhone 16 Pro' },
];

export function getHomeCategorySections() {
  return HOME_CATEGORY_SECTIONS
    .map((section) => ({
      key: section.key,
      pages: section.slugs
        .map((slug) => getComparePageBySlug(slug))
        .filter(Boolean),
    }))
    .filter((section) => section.pages.length > 0);
}

export function getFeaturedComparePages(slugs = HOME_CATEGORY_SECTIONS.flatMap((s) => s.slugs)) {
  return slugs
    .map((slug) => getComparePageBySlug(slug))
    .filter(Boolean);
}

export const CATEGORY_ORDER = [
  'gaming',
  'phones',
  'electronics',
  'audio',
  'computing',
  'fashion',
  'sports',
  'beauty',
  'baby',
  'pets',
  'kitchen',
  'tools',
  'watches',
  'toys',
  'categories',
];

export function getComparePagesByCategory() {
  const grouped = {};
  COMPARE_PAGES.forEach((page) => {
    if (!grouped[page.category]) {
      grouped[page.category] = {
        key: page.category,
        labelHe: page.categoryHe,
        labelEn: page.categoryEn,
        pages: [],
      };
    }
    grouped[page.category].pages.push(page);
  });
  return CATEGORY_ORDER
    .filter((key) => grouped[key])
    .map((key) => grouped[key]);
}

export const CATEGORY_CHIP_SLUGS = {
  catHomeDecor: 'home-decor',
  catBluetoothSpeakers: 'bluetooth-speakers',
  catSmartphones: 'smartphones',
  catKidsToys: 'kids-toys',
};
